export default [
  {
    Name: 'IsoTime',
    name: 'Time',
    userUoM: '-',
    defaultUoM: '-',
    value: 'M_TIMESTAMP',
    description: 'ISO8601 timestamp in UTC',
    label: 'Timestamp',
  },
  {
    Name: 'Elevation',
    name: 'Elevation',
    userUoM: 'm, ft',
    defaultUoM: 'm',
    value: 'M_ELEVATION',
    description: "Elevation from the GPS receiver, adjusted for the receiver's vertical offset",
    label: 'Elevation',
  },
  {
    Name: 'Heading',
    name: 'Heading',
    userUoM: 'arcdeg',
    defaultUoM: 'arcdeg',
    value: 'M_HEADING',
    description: 'Direction of travel',
    label: 'Heading',
  },
  {
    Name: 'Distance',
    name: 'Distance',
    userUoM: 'm, ft',
    defaultUoM: 'm',
    value: 'M_DISTANCE_TRAVELED',
    description: 'Distance travelled since the last recorded point',
    label: 'Distance',
  },
  {
    Name: 'Swathwidth',
    name: 'SecWidth',
    userUoM: 'm, ft',
    defaultUoM: 'm',
    value: 'M_SECTION_WIDTH',
    description: 'Width of the implement section',
    label: 'Section width',
  },
  {
    Name: 'SectionID',
    name: 'SecID',
    userUoM: '-',
    defaultUoM: '-',
    value: 'M_SECTION_ID',
    description: 'The implement section id for this sample',
    label: 'Section ID',
  },
  {
    Name: 'Crop',
    name: 'Crop',
    userUoM: '-',
    defaultUoM: '-',
    value: 'A_DSG_CROP',
    description: 'Crop designator',
    label: 'Crop',
  },
  {
    Name: 'Variety',
    name: 'Product',
    userUoM: '-',
    defaultUoM: '-',
    value: 'A_DSG_PRODUCT',
    description: 'Product designator',
    label: 'Product',
  },
  {
    Name: 'Machine',
    name: 'Machine',
    userUoM: '-',
    defaultUoM: '-',
    value: 'A_DSG_MACHINE',
    description: 'Machine designator',
    label: 'Machine',
  },
  {
    Name: 'VRYieldVol',
    name: 'YldVolRate',
    userUoM: 'l1ha-1, bu1ac-1',
    defaultUoM: 'l1ha-1',
    value: 'A_YLD_VOL_PER_AREA',
    description: 'Volumetric yield (Note this column is only generated for volumetric crops)',
    label: 'Yield vol per area (dry)',
  },
  {
    Name: 'VrYieldMas',
    name: 'YldMasRate',
    userUoM: 'kg1ha-1, lb1ac-1',
    defaultUoM: 'kg1ha-1',
    value: 'A_YLD_MASS_PER_AREA',
    description: 'Yield by mass (Note this column is only generated for mass-based crops)',
    label: 'Yield mass per area (dry)',
  },
  {
    Name: 'VrYieldBal',
    name: 'YldBalRate',
    userUoM: 'bale1ha-1, bale1ac-1',
    defaultUoM: 'bale1ha-1',
    value: 'A_YLD_BALE_PER_AREA',
    description: 'Yield in bales (Note this column is only generated for cotton)',
    label: 'Yield bales per area',
  },
  {
    Name: 'WetMass',
    name: 'WetMasRate',
    userUoM: 'kg1ha-1, lb1ac-1',
    defaultUoM: 'kg1ha-1',
    value: 'A_YLD_WMAS_PER_AREA',
    description: 'The wet (raw) mass reading',
    label: 'Yield mass per area (wet)',
  },
  {
    Name: 'Moisture',
    name: 'Moisture',
    userUoM: 'prcnt',
    defaultUoM: 'prcnt',
    value: 'A_YLD_MOISTURE',
    description: 'The crop moisture reading',
    label: 'Yield moisture',
  },
  {
    Name: 'GrossYldA',
    name: 'GrsMasRate',
    userUoM: 'kg1ha-1, lb1ac-1',
    defaultUoM: 'kg1ha-1',
    value: 'A_YLD_GMAS_PER_AREA',
    description: 'Gross Yield per Area',
    label: 'Gross yield mass per area',
  },
  {
    Name: 'GrossYld',
    name: 'GrsYld',
    userUoM: 'kg, lb',
    defaultUoM: 'kg',
    value: 'A_YLD_GMAS',
    description: 'Gross Yield',
    label: 'Gross yield mass',
  },
  {
    Name: 'NetYld',
    name: 'NetYld',
    userUoM: 'kg, lb',
    defaultUoM: 'kg',
    value: 'A_YLD_NMAS',
    description: 'Net Yield',
    label: 'Net yield mass',
  },
  {
    Name: 'Trash',
    name: 'Trash',
    userUoM: 'prcnt',
    defaultUoM: 'prcnt',
    value: 'A_YLD_TRASH',
    description: 'Out the back mass measurement',
    label: 'Yield trash percent',
  },
  {
    Name: 'ADFPrcnt',
    name: 'ADFPrcnt',
    userUoM: 'prcnt',
    defaultUoM: 'prcnt',
    value: 'A_YLD_ADF',
    description: 'Acid Detergent Fiber Percentage',
    label: 'Yield ADF percent',
  },
  {
    Name: 'NDFPrcnt',
    name: 'NDFPrcnt',
    userUoM: 'prcnt',
    defaultUoM: 'prcnt',
    value: 'A_YLD_NDF',
    description: 'Neutral Detergent Fiber Percentage',
    label: 'Yield NDF percent',
  },
  {
    Name: 'StrchPrcnt',
    name: 'StrchPrcnt',
    userUoM: 'prcnt',
    defaultUoM: 'prcnt',
    value: 'A_YLD_STARCH',
    description: 'Starch Percentage',
    label: 'Yield starch percent',
  },
  {
    Name: 'CrdPrPrcnt',
    name: 'CrdPrPrcnt',
    userUoM: 'prcnt',
    defaultUoM: 'prcnt',
    value: 'A_YLD_CRD_PROTEIN',
    description: 'Crude Protein Percentage',
    label: 'Yield crude protein percent',
  },
  {
    Name: 'SugarPrcnt',
    name: 'SugarPrcnt',
    userUoM: 'prcnt',
    defaultUoM: 'prcnt',
    value: 'A_YLD_SUGAR',
    description: 'Sugar Percentage',
    label: 'Yield sugar percent',
  },
  {
    Name: 'ControlRate',
    name: 'CrlSedRate',
    userUoM: 'seeds1ha-1, seeds1ac-1',
    defaultUoM: 'seeds1ha-1',
    value: 'A_CTRL_SEED_PER_AREA',
    description: 'The prescribed rate in seeds that was sent to the implement',
    label: 'Control seeds per area',
  },
  {
    Name: 'ControlRate',
    name: 'CrlVolRate',
    userUoM: 'l1ha-1, gal1ac-1',
    defaultUoM: 'l1ha-1',
    value: 'A_CTRL_VOL_PER_AREA',
    description: 'The prescribed rate in volume that was sent to the implement',
    label: 'Control volume per area',
  },
  {
    Name: 'ControlRate',
    name: 'CrlMasRate',
    userUoM: 'kg1ha-1, lb1ac-1',
    defaultUoM: 'kg1ha-1',
    value: 'A_CTRL_MASS_PER_AREA',
    description: 'The prescribed rate in mass that was sent to the implement',
    label: 'Control mass per area',
  },
  {
    Name: 'TargetRate',
    name: 'TgtSedRate',
    userUoM: 'seeds1ha-1, seeds1ac-1',
    defaultUoM: 'seeds1ha-1',
    value: 'A_TGT_SEED_PER_AREA',
    description: 'The target seeding rate in the absence of a control rate',
    label: 'Target seeds',
  },
  {
    Name: 'TargetRate',
    name: 'TgtVolRate',
    userUoM: 'l1ha-1, gal1ac-1',
    defaultUoM: 'l1ha-1',
    value: 'A_TGT_VOL_PER_AREA',
    description: 'The target application rate in the absence of a control rate',
    label: 'Target seeds per area (vol)',
  },
  {
    Name: 'TargetRate',
    name: 'TgtMasRate',
    userUoM: 'kg1ha-1, lb1ac-1',
    defaultUoM: 'kg1ha-1',
    value: 'A_TGT_MASS_PER_AREA',
    description: 'The target application rate in the absence of a control rate',
    label: 'Target mass per area',
  },
  {
    Name: 'AppliedRate',
    name: 'ActSedRate',
    userUoM: 'seeds1ha-1, seeds1ac-1',
    defaultUoM: 'seeds1ha-1',
    value: 'A_ACT_SEED_PER_AREA',
    description: 'The measured application rate in seeds',
    label: 'Actual seeds per area',
  },
  {
    Name: 'AppliedRate',
    name: 'ActVolRate',
    userUoM: 'l1ha-1, gal1ac-1',
    defaultUoM: 'l1ha-1',
    value: 'A_ACT_VOL_PER_AREA',
    description: 'The measured application rate in volume',
    label: 'Actual volume per area',
  },
  {
    Name: 'AppliedRate',
    name: 'ActMasRate',
    userUoM: 'kg1ha-1, lb1ac-1',
    defaultUoM: 'kg1ha-1',
    value: 'A_ACT_MASS_PER_AREA',
    description: 'The measured application rate in mass',
    label: 'Actual mass per area',
  },
  { label: 'Total time', value: 'A_TIME_TOTAL' },
  { label: 'Total area', value: 'A_AREA_TOTAL' },
  { label: 'Allocated area', value: 'A_AREA_ALLOCATED' },
  { label: 'Section area', value: 'M_SECTION_AREA' },
  { label: 'Section state', value: 'M_SECTION_ACTIVE' },
  { label: 'Total yield volume (dry)', value: 'A_YLD_VOL_TOTAL' },
  { label: 'Total yield mass (wet)', value: 'A_YLD_WMAS_TOTAL' },
  { label: 'Setpoint seeds per area', value: 'A_SET_SEED_PER_AREA' },
  { label: 'Target total volume', value: 'A_TGT_VOL_TOTAL' },
  { label: 'Actual total volume', value: 'A_ACT_VOL_TOTAL' },
  { label: 'Setpoint volume per area', value: 'A_SET_VOL_PER_AREA' },
  { label: 'Setpoint mass per area', value: 'A_SET_MASS_PER_AREA' },
  { label: 'Target total mass', value: 'A_TGT_MASS_TOTAL' },
  { label: 'Soil moisture', value: 'A_DSD_SOILM' },
  { label: 'Actual total mass', value: 'A_ACT_MASS_TOTAL' },
  { label: 'Soil water tension', value: 'E_SOIL_WATER_TENSION' },
  { label: 'Soil temperature', value: 'E_SOIL_TEMPERATURE' },
];
